var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3058_3187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.666 32C25.5026 32 32.666 24.8366 32.666 16C32.666 7.16344 25.5026 0 16.666 0C7.82946 0 0.666016 7.16344 0.666016 16C0.666016 24.8366 7.82946 32 16.666 32Z",
    fill: "url(#paint0_linear_3058_3187)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62647 16.7867C8.49313 15.7601 10.5865 14.8934 12.5331 14.0267C15.8931 12.6134 19.2531 11.2134 22.6665 9.92005C23.3331 9.69338 24.5198 9.48005 24.6398 10.4667C24.5731 11.8534 24.3198 13.2401 24.1331 14.6134C23.6798 17.6534 23.1465 20.6801 22.6265 23.7067C22.4531 24.7201 21.1865 25.24 20.3731 24.5867C18.4265 23.28 16.4798 21.9734 14.5598 20.6401C13.9331 20.0001 14.5198 19.08 15.0798 18.6267C16.6798 17.0534 18.3731 15.7067 19.8931 14.0534C20.3065 13.0667 19.0931 13.8934 18.6931 14.1467C16.5065 15.6534 14.3731 17.2534 12.0531 18.5867C10.8798 19.24 9.49313 18.68 8.3198 18.32C7.26647 17.8934 5.7198 17.4534 6.62647 16.7867Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3058_3187",
    x1: 21.354,
    y1: 5.05827,
    x2: 11.354,
    y2: 28.3903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37AEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E96C8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3058_3187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.666016)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramLogo);
export default __webpack_public_path__ + "static/media/telegram_logo.254592dd914170f5b7e9c617a85ab96b.svg";
export { ForwardRef as ReactComponent };